import { PCPTranslations } from './PCPTranslations'
import { PDPTranslations } from './PDPTranslations'
import { SERPTranslations } from './SERPTranslations'

export const translations = {
    ...PCPTranslations,
    ...PDPTranslations,
    ...SERPTranslations
}
